class Version extends React.Component {
  render () {
    return (<div>{__MOKA_VERSION__}</div>)
  }
}

export default Version



// WEBPACK FOOTER //
// ./app/pages/Version/Version.js